import React from 'react';
import styled from 'styled-components';
import Toogle from '../../components/Section/Toogle';
import Icon from '../../components/Section/Icon';
import { ServiceCommunication } from '../../types/service';
import { Actions, Categories } from '../../types/gtm';
import { useAuth } from '../../hooks/useAuth';
import VisuallyHidden from '../../components/VisuallyHidden';

const Container = styled.li`
  width: 100%;
  padding: 16px 0px 16px 0px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  &:last-child {
    border-bottom: none;
  }
  > div:first-child {
    display: flex;
    align-items: center;
    > img {
      height: 32px;
      margin-right: 16px;
    }
    > p {
      font-weight: 700;
      font-size: 14px;
      color: #333333;
    }
  }
`;

interface PropsStyled {
  checked?: boolean;
}

const ProductTitle = styled.h3`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;

  color: #333333;
`;

const ContainerToggle = styled.div<PropsStyled>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div:first-child {
    margin-right: 8px;
  }
  > div {
    font-size: 14px;
  }
`;

interface Props {
  serviceCommunication: ServiceCommunication;
  updatePreferences: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  disabled: boolean;
  isUnderage?: boolean;
}

const placeholderIconUrl =
  'https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/logotipo-meus-dados/icone_placeholder.png';

const CommunicationPreferenceService = ({
  serviceCommunication,
  updatePreferences,
  disabled,
  isUnderage = false,
}: Props) => {
  const { user } = useAuth();
  const SendEventToGA = () => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.CommunicationPreferences,
      event_action: Actions.ClickIconCommunication,
      event_label: serviceCommunication.name,
      bd_suser_code: user?.globoId,
    });
  };

  return (
    <Container>
      <div>
        <Icon
          onClick={SendEventToGA}
          svg={serviceCommunication.iconUrl || placeholderIconUrl}
          alt="logo"
        />
        <ProductTitle>{serviceCommunication.name}</ProductTitle>
      </div>
      <ContainerToggle checked={serviceCommunication.newsletter}>
        <div>
          <p>
            Receber <VisuallyHidden>?</VisuallyHidden>
          </p>
        </div>
        <div>
          <Toogle
            checked={serviceCommunication.newsletter}
            htmlFor={serviceCommunication.serviceId.toString()}
            onChange={updatePreferences}
            disabled={disabled || isUnderage}
          />
        </div>
      </ContainerToggle>
    </Container>
  );
};

export default CommunicationPreferenceService;
